var React = require('react');

function Location (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M141.7,13.2c-49.5,0-90,40.5-90,90c0,67.5,90,167.1,90,167.1s90-99.6,90-167.1C231.7,53.7,191.2,13.2,141.7,13.2z\n\t M141.7,135.3c-18,0-32.1-14.1-32.1-32.1S123.7,71,141.7,71s32.1,14.1,32.1,32.1S159.7,135.3,141.7,135.3z"}));
}

Location.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 283.5 283.5","style":{"enableBackground":"new 0 0 283.5 283.5"},"xmlSpace":"preserve"};

module.exports = Location;

Location.default = Location;
